import React from 'react';
import { useSettingQuery } from '../generated/graphql';
import { OLD_TEST_TYPE } from '../entry-points/entry';
import { ValidateState, valid } from '../utils/entry-utils';
import { RadioContainer, Radio } from './entry-form-parts';
import { EntryVisibilityValue } from '../entry-points/admin-setting'

const tTags = ['relo-club', 'benefit', 'genovision'];

export function SelectTestType({ onNext, onPrev, testTypeState, standardFreeOnly, versionState, tTag }: { onNext: () => void; onPrev: () => void; testTypeState: any; standardFreeOnly: boolean; versionState: ValidateState<number | null>; tTag: string | undefined}) {
	const settingQuery = useSettingQuery({
		variables: {
			input: {
				id: 'entryVisibility'
			}
		}
	})
	const entryVisibility = JSON.parse(settingQuery.data?.setting.value ?? '{}') as EntryVisibilityValue
	return <>
		{standardFreeOnly || <>
			<h3>お申し込み区分</h3>
			<RadioContainer>
				{
					tTag && tTags.includes(tTag) ? <>
						{
							tTag === 'relo-club' && 
							<Radio
								state={testTypeState}
								value={OLD_TEST_TYPE.RELO_CLUB}
								name="test-type"
							>
								<div className="detail-radio-label">
									<p>福利厚生俱楽部・クラブオフアライアンスの会員の方</p>
								</div>
							</Radio>
						}
						{
							tTag === 'benefit' && 
							<Radio
								state={testTypeState}
								value={OLD_TEST_TYPE.BENEFIT}
								name="test-type"
							>
								<div className="detail-radio-label">
									<p>ベネフィット会員の方</p>
								</div>
							</Radio>
						}
						{
							tTag === 'genovision' && 
							<Radio
								state={testTypeState}
								value={OLD_TEST_TYPE.GENOVISION}
								name="test-type"
							>
								<div className="detail-radio-label">
									<p>Genovision®会員の方</p>
								</div>
							</Radio>
						}
					</>:<>
						<Radio state={testTypeState} value={OLD_TEST_TYPE.COUPON} name="test-type">
							<div className="detail-radio-label">
								<p>MBコード（クーポンコード）をお持ちの方</p>
							</div>
						</Radio>
						{/*
							<Radio state={testTypeState} value={OLD_TEST_TYPE.RIEBE} name="test-type">
									<div className="detail-radio-label">
											<p>一般社団法人企業福祉・共済総合研究所会員関係者の方</p>
									</div>
							</Radio>
						*/}
						<Radio
							state={testTypeState}
							value={OLD_TEST_TYPE.SAPPORO_CHUSHO}
							name="test-type"
							disabled={entryVisibility['sapporo-chusho'] && entryVisibility['sapporo-chusho'] === 'disabled'}
							hide={entryVisibility['sapporo-chusho'] && entryVisibility['sapporo-chusho'] === 'hide'}
						>
							<div className="detail-radio-label">
								<p>公財 札幌市中小企業共済センター（さぽーとさっぽろ）会員の方</p>
							</div>
						</Radio>
						<Radio
							state={testTypeState}
							value={OLD_TEST_TYPE.KYOFUKU}
							name="test-type"
							disabled={entryVisibility['kyofuku'] && entryVisibility['kyofuku'] === 'disabled'}
							hide={entryVisibility['kyofuku'] && entryVisibility['kyofuku'] === 'hide'}
						>
							<div className="detail-radio-label">
								<p>一般財団法人神奈川県教育福祉振興会関係者の方</p>
							</div>
						</Radio>
						<Radio
							state={testTypeState}
							value={OLD_TEST_TYPE.BOHSEI}
							name="test-type"
							disabled={entryVisibility['bohsei'] && entryVisibility['bohsei'] === 'disabled'}
							hide={entryVisibility['bohsei'] && entryVisibility['bohsei'] === 'hide'}
						>
							<div className="detail-radio-label">
								<p>株式会社望星薬局社員の方</p>
							</div>
						</Radio>
						<Radio
							state={testTypeState}
							value={OLD_TEST_TYPE.GENOVISION}
							name="test-type"
							disabled={entryVisibility['genovision'] && entryVisibility['genovision'] === 'disabled'}
							hide={entryVisibility['genovision'] && entryVisibility['genovision'] === 'hide'}
						>
							<div className="detail-radio-label">
								<p>Genovision®会員の方</p>
							</div>
						</Radio>
						<Radio
							state={testTypeState}
							value={OLD_TEST_TYPE.GOLDEN_LOOP}
							name="test-type"
							disabled={entryVisibility['golden-loop'] && entryVisibility['golden-loop'] === 'disabled'}
							hide={entryVisibility['golden-loop'] && entryVisibility['golden-loop'] === 'hide'}
						>
							<div className="detail-radio-label">
								<p>ゴールデンループ読者、およびご紹介の方</p>
							</div>
						</Radio>
						<Radio
							state={testTypeState}
							value={OLD_TEST_TYPE.RELO_CLUB}
							name="test-type"
							disabled={entryVisibility['relo-club'] && entryVisibility['relo-club'] === 'disabled'}
							hide={entryVisibility['relo-club'] && entryVisibility['relo-club'] === 'hide'}
						>
							<div className="detail-radio-label">
								<p>福利厚生俱楽部・クラブオフアライアンスの会員の方</p>
							</div>
						</Radio>
						<Radio
							state={testTypeState}
							value={OLD_TEST_TYPE.BENEFIT}
							name="test-type"
							disabled={entryVisibility['benefit'] && entryVisibility['benefit'] === 'disabled'}
							hide={entryVisibility['benefit'] && entryVisibility['benefit'] === 'hide'}
						>
							<div className="detail-radio-label">
								<p>ベネフィット会員の方</p>
							</div>
						</Radio>
						{/*
							<Radio state={testTypeState} value={Infinity} disabled name="test-type">
									<div className="detail-radio-label">
											<p>法人MBクラブ会員企業関係者の方</p>
											<p><small>ただいま準備中です</small></p>
									</div>
							</Radio>
						*/}
					</>
				}
			</RadioContainer>
		</>}
		<div className="button-container">
			<button className="prev-button" onClick={() => {
				onPrev();
			}}>戻る</button>
			<div className="spacer"></div>
			<button className="next-button" disabled={!(valid(testTypeState))} onClick={() => {
				onNext();
			}}>次へ</button>
		</div>
	</>;
}
